import { useState, useEffect } from "react";
const useApiClient = ({
  apiClient,
  // implementation of ApiClientInterface
  name,
  method,
  path,
  defaultValue = null,
  formatResultFunc = unformattedResult => unformattedResult,
  preventStateResult = false // When true, the result will not be set in state (only returned). This is useful for large responses like a base64 image (to reduce lag)
}) => {
  const [result, setResult] = useState(defaultValue);
  useEffect(() => {
    registerEndpoint();
  }, [path]);
  const registerEndpoint = () => {
    apiClient.registerEndpoint(name, method, path);
  };
  const updateResultOnResolve = async resultPromise => {
    const newResult = await resultPromise;
    if (preventStateResult === false) {
      setResult(newResult);
    }
  };
  const sendRequest = payload => {
    let resultPromise;
    try {
      resultPromise = apiClient[name](payload);
    } catch (error) {
      // if the endpoint has not been registered yet (race condition),
      // the register it and try to send the request again
      if (error instanceof TypeError) {
        registerEndpoint();
        return sendRequest(payload);
      }
    }
    const formattedResultPromise = resultPromise.then(res => formatResultFunc(res));
    updateResultOnResolve(formattedResultPromise);
    return formattedResultPromise;
  };
  return [sendRequest, result];
};
export { useApiClient };